import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PrivacyTag, LevelSelector, Level } from './styles';

class PrivacyElement extends Component {
  changeLevel = (level) => {
    const { element, onChange } = this.props;
    if (onChange) {
      onChange(element.id, level);
    }
  }

  selectLevel0 = (event) => {
    this.changeLevel(0);
    event.stopPropagation();
  }

  selectLevel1 = (event) => {
    this.changeLevel(1);
    event.stopPropagation();
  }

  selectLevel2 = (event) => {
    this.changeLevel(2);
    event.stopPropagation();
  }

  selectLevel3 = (event) => {
    this.changeLevel(3);
    event.stopPropagation();
  }

  handleClick = (event) => {
    const { onClick, element } = this.props;
    if (onClick) {
      onClick(element.id);
      event.stopPropagation();
    }
  }

  printLevelSelector = () => {
    const { color, level } = this.props;

    if (!this.tag) {
      return null;
    }
    const clientRect = this.tag.getBoundingClientRect();
    const top = clientRect.top - 50 + window.scrollY;
    const left = clientRect.left + (clientRect.width / 2) - 15;
    return (
      <LevelSelector top={top} left={left}>
        <Level color={color} selected={level === 0} onClick={this.selectLevel0}>
          <i className='fa fa-wifi' />
        </Level>
        <Level color={color} selected={level === 1} onClick={this.selectLevel1}>
          <i className='fa fa-user-shield' />
        </Level>
        <Level color={color} selected={level === 2} onClick={this.selectLevel2}>
          <i className='fa fa-comments' />
        </Level>
        <Level color={color} selected={level === 3} onClick={this.selectLevel3}>
          <i className='fa fa-lock' />
        </Level>
      </LevelSelector>
    );
  }

  assignRef = (ref) => {
    this.tag = ref;
  }

  render() {
    const { element, selected, color } = this.props;
    return (
      <React.Fragment>
        {selected && this.printLevelSelector()}
        <div className='tag gray' color={color} selected={selected} ref={this.assignRef} onClick={this.handleClick}>{element.name || element.element.name}</div>
      </React.Fragment>
    );
  }
}

PrivacyElement.propTypes = {
  element: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  color: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  onChange: PropTypes.func,
};

PrivacyElement.defaultProps = {
  selected: false,
  onClick: null,
  onChange: null,
};

export default PrivacyElement;



// WEBPACK FOOTER //
// ./src/routes/Profile/components/PrivacyElement.jsx